// extracted by mini-css-extract-plugin
module.exports = {"tableHighlightWrapper":"sMAs6","tableHighlightColumn":"_1pz_G","tableHighlightRow":"Lszn0"};